import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${fluid(24, 48)};

  @media ${from(Device.Desktop)} {
    justify-content: flex-start;
    flex-direction: row-reverse;
  }
`;
const PaginationStyles = {
    Container,
};
export default PaginationStyles;
